<template>
  <div class="home">
    <div class="error" v-if="error">Could not fetch the data</div>
    <div v-if="documents">
      <Listview :playlists="documents" />
    </div>
    <div v-if="!documents">
      <Spinner />
    </div>
    <div class="chatroom">
    <Chatroom />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Spinner from '../components/Spinner'
import Chatroom from '../components/Chatroom'
import getCollection from '../composables/getCollection'
import Listview from '../components/Listview'

export default {
  name: 'Home',
  components: {
    Listview,
    Chatroom,
    Spinner
  },
  setup() {
    const { error, documents } = getCollection('playlists');
    console.log(documents);
    return { error, documents };
  }
}
</script>
